import { FormEvent } from "react";

interface IProps {
    name: string,
    yes: boolean,
    no: boolean,
    unknown?: boolean,
    onChange?: (name: string, value: boolean) => void,
    onChangeNumber?: (name: string, value: number) => void
}

const YesNoUnknown = (props: IProps) => {
    const handleClick = (e: FormEvent<HTMLInputElement>) => {
        if (props.onChangeNumber) {
            if (e.currentTarget.value == '1') {
                props.onChangeNumber(e.currentTarget.name, 1);
            }
    
            if (e.currentTarget.value == '0') {
                props.onChangeNumber(e.currentTarget.name, 0);
            }
    
            if (e.currentTarget.value == '-1') {
                props.onChangeNumber(e.currentTarget.name, null);
            }
        } else {
            if (e.currentTarget.value == '1') {
                props.onChange(e.currentTarget.name, true);
            }
    
            if (e.currentTarget.value == '0') {
                props.onChange(e.currentTarget.name, false);
            }
    
            if (e.currentTarget.value == '-1') {
                props.onChange(e.currentTarget.name, null);
            }
        }
    };

    return (
        <div className='yes-no-unknown'>
            <label className='radio-inline' style={{paddingTop: 0}}>
                <input id={props.name + 'Yes'} name={props.name} type='radio' checked={props.yes} value={1} onClick={handleClick} /> Yes
            </label>
            <label className='radio-inline' style={{paddingTop: 0}}>
                <input id={props.name + 'No'} name={props.name} type='radio' checked={props.no} value={0} onClick={handleClick} /> No
            </label>
            {props.unknown != null && (
                <label className='radio-inline' style={{paddingTop: 0}}>
                    <input id={props.name + 'Unknown'} name={props.name} type='radio' checked={props.unknown} value={-1} onClick={handleClick} /> Unknown
                </label>
            )}
        </div>
    );
}

export default YesNoUnknown;